import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router";
import { getDataCot } from "../../Fetch/GetPDF";
import Loading from "../../Components/Loading/Loading";
import LinkPanel from "./LinkPanel"

export default function LinkViewOld() {
  //let params = useParams();
  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const [data, setData] = useState(
    {
      "status": 'error',
      "message": '',
      "valid": false,
      "payload": {
        "cot": []
      }
    })
  useEffect(() => {

    getDataCot(searchParams.get("hash")).then(res => {
      //console.log(res)
      if (res.valid) {
        setData(v => (
          {
            ...v,
            status: res.status,
            message: res.message,
            valid: res.valid,
            payload: {
              ...v.payload,
              cot: res.payload.cot,
            }
          }
        ))
      }
    })

  }, [searchParams, setData])

  if (data.valid) {
    if (data.payload.cot.length > 0) {
      return (
        data.payload.cot.map((cot, icot) => {
          if (cot.oc.length <= 0) {
            navigate(`/LinkCot/${searchParams.get("hash")}`)
            return (<Loading/>)

          } else {
            return (
              <LinkPanel key={icot} idC={cot.idCotizacion} hash={searchParams.get("hash")} data={cot} />
            )
          }
        }))
    }
  }
}
